export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/ob-step-1.png?9b8ba7c08a2ea4a3dc77049a637c6d4a";